// Centralized AI model configuration for frontend
// Update model names here to change them across the entire frontend

const MODELS = {
  // Realtime voice interview sessions
  REALTIME: "gpt-realtime-2",
};

export default MODELS;
